import { useState } from "react";

import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import { axios } from "setups/axios";

const Login = () => {
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");

  const validate = () => {
    let error = "";

    if (!data.email || !data.password)
      error = "Please provide both Email and Password.";

    setError(error);

    if (error) return false;

    return true;
  };

  const loginHandler = async () => {
    if (!validate()) return;

    const res = await axios()({
      url: `/api/v1/login/master`,
      method: "POST",
      data,
    }).catch((error) => {
      console.log(error.response);

      setError(error?.response?.data?.message);

      return;
    });

    if (res) {
      const { data } = res.data;

      localStorage.setItem("token", data.token);

      location.reload();
    }

    console.log(res?.data);
  };

  return (
    <Stack spacing={2.5} sx={{ width: "100%" }}>
      {error && <Alert severity="error">{error}</Alert>}

      <TextField
        fullWidth
        size="small"
        label="Email"
        placeholder="Email"
        value={data.email}
        onChange={(e) => setData({ ...data, email: e.target.value })}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <EmailOutlinedIcon fontSize="small" color="action" />
            </InputAdornment>
          ),
        }}
      />

      <TextField
        fullWidth
        size="small"
        type="password"
        label="Password"
        placeholder="Password"
        value={data.password}
        onChange={(e) => setData({ ...data, password: e.target.value })}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <LockOutlinedIcon fontSize="small" color="action" />
            </InputAdornment>
          ),
        }}
      />

      <Button
        fullWidth
        size="large"
        variant="contained"
        color="primary"
        onClick={loginHandler}
        sx={{ fontWeight: 700 }}
      >
        Login
      </Button>
    </Stack>
  );
};

export default Login;
